@if (price.bulkPrices; as bulkPrices) {
  <div class="price-scale">
    @for (bulk of bulkPrices; track $index) {
      <div class="price-scale-headline">
        <h5 class="price-scale-title" [class.small]="small">
          {{
            'cartridge.priceModel.' + price.priceModel
              | transloco
                : {
                    unit: bulk | getServicePackageName: servicePackage,
                    period:
                      ('cartridge.priceModel.billingPeriod.' +
                        price.billingPeriod | transloco),
                  }
          }}
        </h5>
        <markant-icon class="info-icon" icon="m_info-small" colorScheme="dark">
          <markant-tooltip
            [label]="
              'cartridge.bulkPrice.tooltip.' + price.priceModel | transloco
            "
            placement="left"
          >
          </markant-tooltip>
        </markant-icon>
      </div>
      <div class="price-scale-table" [class.small]="small">
        @for (tier of bulk.tiers | sortTiers; track $index) {
          <div class="price-scale-table-row">
            <span class="price-scale-table-cell">
              <span
                class="price-scale-table-cell-label"
                [class.small]="small"
                >{{
                  'cartridge.bulkPrice.scale'
                    | transloco: { minimum: tier.minimalNumber + 1 }
                }}</span
              >
            </span>
            <span class="price-scale-table-cell align-end">
              <span
                class="price-scale-table-cell-price"
                [class.small]="small"
                >{{ formatPrice(tier.decimilliesAmount, price.currency) }}</span
              >
              @if (!isFixedPrice || $index === bulk.tiers.length - 1) {
                <span
                  class="price-scale-table-cell-service-package"
                  [class.small]="small"
                >
                  / {{ bulk | getServicePackageName: servicePackage }}</span
                >
              }
            </span>
          </div>
        }
      </div>
    }
  </div>
}

<section class="price-conditions-wrapper">
  <div class="price vat flex-col-end markant-caption" [class.small]="small">
    <div>{{ 'cartridge.priceExcludingVAT' | transloco }}</div>
  </div>

  @if (price.bulkPrices) {
    <div class="flex-row-end">
      <markant-platform-price-metadata [price]="price" />
    </div>
  }
</section>
